/* ==========================================================================
   Koolseed — Ürün detay
   Galeri (sekmeli + kaydırmalı) ve mobil sabit bar.
   ========================================================================== */

(function () {
  'use strict';

  class KsGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ks-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.ks-gallery__thumb'));
      this.counter = this.querySelector('[data-gallery-counter]');
      this.index = 0;
      if (this.slides.length < 1) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(Number(thumb.dataset.index)));
      });

      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      // Ok tuşlarıyla gezinme — küçük resimler sekme rolünde.
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
      });

      this.bindSwipe();
    }

    bindSwipe() {
      const stage = this.querySelector('.ks-gallery__stage');
      if (!stage) return;
      let startX = null;

      stage.addEventListener('touchstart', (e) => {
        // Videonun ilerleme çubuğunu sürüklemek galeriyi kaydırmasın.
        startX = e.target.closest('video, iframe') ? null : e.changedTouches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 45) this.step(delta < 0 ? 1 : -1);

        // Görsel artık inceleyiciyi açan bir buton; kaydırma hareketi
        // dokunuşun bittiği yerde click de tetikliyor. Kayma varsa o click'i
        // yakalama aşamasında bir kereliğine yutuyoruz.
        if (Math.abs(delta) > 10) {
          const swallow = (event) => {
            event.stopPropagation();
            event.preventDefault();
          };
          stage.addEventListener('click', swallow, { capture: true, once: true });
          window.setTimeout(() => stage.removeEventListener('click', swallow, { capture: true }), 400);
        }
        startX = null;
      }, { passive: true });
    }

    /* Gizlenen slayttaki video susmuyor — display:none sesi kesmiyor.
       Yüklenen video doğrudan durduruluyor; YouTube/Vimeo'ya oynatıcı
       API'siyle "dur" komutu gönderiliyor (ikisi de tanımadığı mesajı
       yok sayıyor). */
    pauseMedia(slide) {
      slide.querySelectorAll('video').forEach((video) => {
        if (!video.paused) video.pause();
      });
      slide.querySelectorAll('iframe').forEach((frame) => {
        if (!frame.contentWindow) return;
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
        frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      });
    }

    step(direction) {
      const count = this.slides.length;
      this.show((this.index + direction + count) % count);
    }

    show(index) {
      this.slides.forEach((slide, i) => {
        const active = i === index;
        if (!active && !slide.hidden) this.pauseMedia(slide);
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      this.thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
        if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      if (this.counter) this.counter.textContent = `${index + 1} / ${this.slides.length}`;
      this.index = index;
    }
  }
  if (!customElements.get('ks-gallery')) customElements.define('ks-gallery', KsGallery);

  class KsStickyBar extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector(this.dataset.watch);
      if (!target || !('IntersectionObserver' in window)) return;

      // "Sepete Ekle" ekrandayken bar gizli, değilken görünür. Alt kenardan
      // barın kendi yüksekliği kadar pay bırakıyoruz ki butonu tam örttüğü
      // anda bar açık kalmasın ve iki durum arasında titremesin.
      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries[0].isIntersecting;
          this.hidden = visible;
          this.classList.toggle('is-visible', !visible);
        },
        { rootMargin: '0px 0px -76px 0px' }
      );
      this.observer.observe(target);

      // IntersectionObserver ilk gözlemi bir sonraki karede verdiği için
      // sayfa açılışında bar bir an gizli kalıyor; başlangıç durumunu
      // ölçüp hemen kuruyoruz.
      const box = target.getBoundingClientRect();
      const initiallyVisible = box.bottom > 0 && box.top < window.innerHeight - 76;
      this.hidden = initiallyVisible;
      this.classList.toggle('is-visible', !initiallyVisible);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  if (!customElements.get('ks-sticky-bar')) customElements.define('ks-sticky-bar', KsStickyBar);
})();

/* Sekmeli içerik ("İçinde Ne Var"). Klavyeyle ok tuşu desteği dahil. */
(function () {
  'use strict';

  class KsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.show(Number(tab.dataset.index)));
        tab.addEventListener('keydown', (event) => {
          const dir = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          event.preventDefault();
          const next = (Number(tab.dataset.index) + dir + this.tabs.length) % this.tabs.length;
          this.show(next);
          this.tabs[next].focus();
        });
      });
    }

    show(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }
  }
  if (!customElements.get('ks-tabs')) customElements.define('ks-tabs', KsTabs);
})();

/* Sepete ekle butonundaki satır toplamı — tasarımda "Sepete Ekle · ₺1.145"
   yazıyor ve adet değiştikçe güncelleniyor. Para birimi biçimi mağazanın
   kendi ayarından geldiği için ilk basılan metni şablon olarak kullanıp
   yalnızca sayıyı değiştiriyoruz. */
(function () {
  'use strict';

  function formatFromTemplate(template, amountMinor) {
    // Şablon: "· ₺1.145,00" gibi. Rakam bloğunu bulup yerine yenisini koyuyoruz.
    var match = template.match(/[\d.,]+/);
    if (!match) return template;
    var sample = match[0];
    var decimalSep = /,\d{2}$/.test(sample) ? ',' : (/\.\d{2}$/.test(sample) ? '.' : null);
    var groupSep = decimalSep === ',' ? '.' : ',';

    var major = Math.floor(amountMinor / 100);
    var minor = String(amountMinor % 100).padStart(2, '0');
    var grouped = String(major).replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
    var next = decimalSep ? grouped + decimalSep + minor : grouped;
    return template.replace(sample, next);
  }

  function init(form) {
    var button = form.querySelector('[data-line-total]');
    var valueEl = form.querySelector('[data-line-total-value]');
    var qty = form.querySelector('input[name="quantity"]');
    if (!button || !valueEl || !qty) return;

    var unit = Number(button.dataset.unitPrice || 0);
    var template = valueEl.textContent;
    if (!unit) return;

    var update = function () {
      var n = Math.max(1, Number(qty.value) || 1);
      valueEl.textContent = formatFromTemplate(template, unit * n);
    };

    qty.addEventListener('change', update);
    qty.addEventListener('input', update);
    update();
  }

  var start = function () {
    document.querySelectorAll('[data-line-total]').forEach(function (button) {
      var form = button.closest('form');
      if (form) init(form);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
